export const getUUID = () =>
  Math.random()
    .toString(36)
    .slice(2);
